import { BodyMeasurementKey } from 'hevy-shared';

export const measurementKeyTitleMap: { [key in BodyMeasurementKey]: string } = {
  weight_kg: 'Body Weight',
  fat_percent: 'Body Fat',
  neck_cm: 'Neck',
  shoulder_cm: 'Shoulder',
  chest_cm: 'Chest',
  left_bicep_cm: 'Left Bicep',
  right_bicep_cm: 'Right Bicep',
  left_forearm_cm: 'Left Forearm',
  right_forearm_cm: 'Right Forearm',
  abdomen: 'Abdomen',
  waist: 'Waist',
  hips: 'Hips',
  left_thigh: 'Left Thigh',
  right_thigh: 'Right Thigh',
  left_calf: 'Left Calf',
  right_calf: 'Right Calf',
  lean_mass_kg: 'Lean Body Mass',
};
